import { render, staticRenderFns } from "./l-dialog.vue?vue&type=template&id=eb23ab50&scoped=true"
import script from "./l-dialog.vue?vue&type=script&lang=js"
export * from "./l-dialog.vue?vue&type=script&lang=js"
import style0 from "./l-dialog.vue?vue&type=style&index=0&id=eb23ab50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb23ab50",
  null
  
)

export default component.exports